import { ReactNode } from 'react'

interface PreLoginLayoutProps {
  children: ReactNode
}

/**
 * PreLoginLayout - Shared layout for pre-authentication pages
 *
 * Provides consistent styling matching the landing page for sign-in and sign-up pages.
 * Features a purple gradient background and centered content area.
 */
const PreLoginLayout = ({ children }: PreLoginLayoutProps) => {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif'
      }}
    >
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '64px 24px'
        }}
      >
        {children}
      </div>

      {/* Footer */}
      <div
        style={{
          padding: '24px',
          textAlign: 'center',
          borderTop: '1px solid rgba(255, 255, 255, 0.2)',
          backgroundColor: 'rgba(0, 0, 0, 0.1)'
        }}
      >
        <p
          style={{
            margin: 0,
            fontSize: '0.875rem',
            color: 'rgba(255, 255, 255, 0.8)'
          }}
        >
          A modern desk booking solution for hybrid teams
        </p>
      </div>
    </div>
  )
}

export default PreLoginLayout
